import { institutionLoginsSelectors } from 'app-components/flux/institution-logins';
import store from 'app-components/utils/redux-store';
import { v4 as uuidv4 } from 'uuid';

const baseAccount = () => ({
  clientId: uuidv4(),
});

const assetTopBalance = 80000;
const assetBottomBalance = 800;
const liabilityTopBalance = -30000;
const liabilityBottomBalance = -1000;

const mockAccounts = () => {
  if (store) {
    const institutionLogins = institutionLoginsSelectors.getResourcesById(store.getState());
    const nameHas = (name: string) =>
      institutionLogins.find((institutionLogin) => institutionLogin.name.toLowerCase().includes(name.toLowerCase()));
    const accounts = [
      ...(nameHas('Chase')
        ? [
            {
              institutionLoginId: nameHas('Chase')?.id,
              name: `Chase Checking ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'CHECKING',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
            {
              institutionLoginId: nameHas('Chase')?.id,
              name: `Chase Savings ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'SAVINGS',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
            {
              institutionLoginId: nameHas('Chase')?.id,
              name: `Chase Credit Card ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'CREDIT',
              subType: 'CREDIT_CARD',
              balanceAsOf: liabilityBottomBalance + Math.random() * (liabilityTopBalance - liabilityBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('American Express')
        ? [
            {
              institutionLoginId: nameHas('American Express')?.id,
              name: `American Express ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'CREDIT',
              subType: 'CREDIT_CARD',
              balanceAsOf: liabilityBottomBalance + Math.random() * (liabilityTopBalance - liabilityBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('Fidelity')
        ? [
            {
              institutionLoginId: nameHas('Fidelity')?.id,
              name: `Fidelity IRA ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'INVESTMENT',
              subType: 'IRA',
              onlineBalance: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('Capital One')
        ? [
            {
              institutionLoginId: nameHas('Capital One')?.id,
              name: `Capital One CD ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'CD',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('Bank of America')
        ? [
            {
              institutionLoginId: nameHas('Bank of America')?.id,
              name: `BofA Credit Card ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'CREDIT_CARD',
              balanceAsOf: liabilityBottomBalance + Math.random() * (liabilityTopBalance - liabilityBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('Citibank')
        ? [
            {
              institutionLoginId: nameHas('Citibank')?.id,
              name: `Citibank Costco Card ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'CREDIT',
              subType: 'CREDIT_CARD',
              balanceAsOf: liabilityBottomBalance + Math.random() * (liabilityTopBalance - liabilityBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('Wells Fargo')
        ? [
            {
              institutionLoginId: nameHas('Wells Fargo')?.id,
              name: `Wells Fargo Checking ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')} (spouse)`,
              type: 'BANK',
              subType: 'CHECKING',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
            {
              institutionLoginId: nameHas('Wells Fargo')?.id,
              name: `Wells Fargo Savings ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')} (spouse)`,
              type: 'BANK',
              subType: 'SAVINGS',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('Charles Schwab')
        ? [
            {
              institutionLoginId: nameHas('Charles Schwab')?.id,
              name: `Schwab Brokerage ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'INVESTMENT',
              subType: 'RoTH_IRA',
              onlineBalance: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('Vanguard')
        ? [
            {
              institutionLoginId: nameHas('Vanguard')?.id,
              name: `Vanguard 401K ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'INVESTMENT',
              subType: '401K',
              onlineBalance: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('Discover')
        ? [
            {
              institutionLoginId: nameHas('Discover')?.id,
              name: `Discover Card ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'CREDIT',
              subType: 'CREDIT_CARD',
              balanceAsOf: liabilityBottomBalance + Math.random() * (liabilityTopBalance - liabilityBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('AllyBank')
        ? [
            {
              institutionLoginId: nameHas('AllyBank')?.id,
              name: `Ally Savings ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'SAVINGS',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('Robinhood')
        ? [
            {
              institutionLoginId: nameHas('Robinhood')?.id,
              name: `Robinhood Brokerage ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'INVESTMENT',
              subType: 'BROKERAGE',
              onlineBalance: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('USAA')
        ? [
            {
              institutionLoginId: nameHas('USAA')?.id,
              name: `USAA Car Loan ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'LOAN',
              subType: 'AUTO',
              onlineBalance: -20000 + Math.random() * -50000,
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('U.S. Bank')
        ? [
            {
              institutionLoginId: nameHas('U.S. Bank')?.id,
              name: `U.S. Mortgage ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'LOAN',
              subType: 'MORTGAGE',
              onlineBalance: -100000 + Math.random() * -1000000,
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('Venmo')
        ? [
            {
              institutionLoginId: nameHas('Venmo')?.id,
              name: `Venmo Account ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'CHECKING',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('PayPal')
        ? [
            {
              institutionLoginId: nameHas('PayPal')?.id,
              name: `PayPal Account ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'CHECKING',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
          ]
        : []),
      ...(nameHas('E*Trade Investments')
        ? [
            {
              institutionLoginId: nameHas('E*Trade Investments')?.id,
              name: `E*Trade Brokerage ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'INVESTMENT',
              subType: 'ROTH_401K',
              onlineBalance: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('SoFi')
        ? [
            {
              institutionLoginId: nameHas('SoFi')?.id,
              name: `SoFi Student Loan ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'LOAN',
              subType: 'STUDENT',
              onlineBalance: -10000 + Math.random() * -50000,
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
      ...(nameHas('Barclays')
        ? [
            {
              institutionLoginId: nameHas('Barclays')?.id,
              name: `Barclays Savings ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'BANK',
              subType: 'SAVINGS',
              balanceAsOf: assetBottomBalance + Math.random() * (assetTopBalance - assetBottomBalance),
              balanceAsOfOn: '2023-12-31',
            },
            {
              institutionLoginId: nameHas('Barclays')?.id,
              name: `Barclays Construction Loan ${Math.floor(Math.random() * 9999)
                .toString()
                .padStart(4, '0')}`,
              type: 'LOAN',
              subType: 'CONSTRUCTION',
              onlineBalance: -20000 + Math.random() * -200000,
              onlineBalanceAt: '2023-12-31T19:00:00Z',
            },
          ]
        : []),
    ];
    return accounts.map((account) => ({
      ...baseAccount(),
      ...account,
    }));
  }
  return [];
};

export default mockAccounts;
